import styled from "@emotion/styled";

import { ThemeMode } from "../../../context/ThemeContext";

export const AppHeaderWrapper = styled.header<{
  mode: ThemeMode;
  isPanoramicResults?: boolean;
}>`
  box-sizing: border-box;
  padding: 24px 0;
  background: ${(props) => (props.mode === "dark" ? "#1F242A" : "#ffffff")};

  @media (max-width: 768px) {
    padding: 16px 0;
  }

  .MuiContainer-root {
    @media (max-width: 768px) {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }

  .logo {
    display: flex;
    align-items: center;
    height: 25px;

    img {
      height: 100%;
      width: auto;
    }

    @media (max-width: 480px) {
      height: 20px;
    }
  }

  .header {
    height: 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
      height: auto;
    }

    .burger-btn {
      padding: 8px;
      color: ${(props) => (props.mode === "dark" ? "#F0F0F0" : "#333333")};
    }

    .desktop-menu {
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      list-style-type: none;

      @media (max-width: 768px) {
        display: none;
      }

      li {
        margin-right: 22px;

        &:last-child {
          margin-right: 0;
        }

        .MuiButton-root {
          font-size: 14px;
          padding: 6px 12px;
          min-width: auto;
        }
      }
    }

    .mobile-controls {
      display: none;
      align-items: center;
      gap: 8px;

      @media (max-width: 768px) {
        display: flex;
      }
    }
  }
`;

export const MobileMenuContent = styled.div<{ mode: ThemeMode }>`
  width: 280px;
  height: 100%;
  background: ${(props) => (props.mode === "dark" ? "#1F242A" : "#ffffff")};
  display: flex;
  flex-direction: column;

  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid
      ${(props) => (props.mode === "dark" ? "#353944" : "#E2E8F0")};

    .logo {
      height: 20px;

      img {
        height: 100%;
        width: auto;
      }
    }

    .close-btn {
      color: ${(props) => (props.mode === "dark" ? "#F0F0F0" : "#333333")};
    }
  }

  .menu-list {
    flex: 1;
    padding: 16px 0;
    list-style: none;
    margin: 0;

    li {
      padding: 0;

      .MuiButton-root {
        width: 100%;
        justify-content: flex-start;
        padding: 12px 24px;
        font-size: 16px;
        color: ${(props) => (props.mode === "dark" ? "#F0F0F0" : "#333333")};
        text-transform: none;

        &:hover {
          background: ${(props) =>
            props.mode === "dark" ? "#353944" : "#F0F0F0"};
        }
      }
    }
  }

  .menu-footer {
    padding: 16px;
    border-top: 1px solid
      ${(props) => (props.mode === "dark" ? "#353944" : "#E2E8F0")};
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
